import { c as _c } from "react/compiler-runtime";
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import fAQSrc from '@classify/illustrations/fAQ';
import supportCompanionSrc from '@classify/illustrations/supportCompanion';
import Typography from '@classify/react-core-components/Typography';
import { ImageCdn } from '@openclassrooms/images-cdn';
import EnrichText from '@classify/react-core-components/EnrichText';
import Callout from '@classify/react-core-components/Callout';
import Translate from '@openclassrooms/translations/components/Translate';
import { translate } from '@openclassrooms/translations';
import { LinkHandler } from '@openclassrooms/routing/components';
import { useCurrentUserContext } from '@openclassrooms/data-connect-web/users';
import { helpSession } from '@openclassrooms/common-app/contact/services';
import { HelpType } from './ContactProvider/useHelpTypeFromPathname';
type HeaderType = Exclude<HelpType, 'none'>;
function Header(t0) {
  const $ = _c(9);
  const {
    title,
    subTitle,
    image
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mb: 2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <Typography variant="h3" component="h1" sx={t1}>{title}</Typography>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== subTitle) {
    t3 = <EnrichText><Typography dangerouslySetInnerHTML={{
        __html: subTitle
      }} /></EnrichText>;
    $[3] = subTitle;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== image || $[6] !== t2 || $[7] !== t3) {
    t4 = <div>{image}{t2}{t3}</div>;
    $[5] = image;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
type Props = {
  type: HeaderType;
  onSwitchHelpType: () => void;
};
export default function PageHeader(t0) {
  const $ = _c(26);
  const {
    type,
    onSwitchHelpType
  } = t0;
  const {
    currentUser
  } = useCurrentUserContext();
  const {
    getLocalisationConfig
  } = useLocalisationConfig();
  let t1;
  if ($[0] !== getLocalisationConfig) {
    t1 = helpSession.hasStarted() && getLocalisationConfig("contact.companion.activated");
    $[0] = getLocalisationConfig;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hasHelpSessionStarted = t1;
  let t2;
  if ($[2] !== type) {
    t2 = type === "student" ? translate("support.global.title") : translate("support.business.title");
    $[2] = type;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let title = t2;
  if (currentUser?.firstName && type === "student") {
    let t3;
    if ($[4] !== currentUser.firstName) {
      t3 = translate("support.global.ai.title", {
        name: currentUser.firstName
      });
      $[4] = currentUser.firstName;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    title = t3;
  }
  let t3;
  if ($[6] !== getLocalisationConfig || $[7] !== type) {
    t3 = type === "student" ? translate("support.global.subheading", {
      url: String(getLocalisationConfig("faq.student.url"))
    }) : translate("support.business.subheading", {
      url: String(getLocalisationConfig("faq.employer.url"))
    });
    $[6] = getLocalisationConfig;
    $[7] = type;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let subTitle = t3;
  if (hasHelpSessionStarted) {
    let t4;
    if ($[9] !== getLocalisationConfig) {
      t4 = getLocalisationConfig("faq.student.url");
      $[9] = getLocalisationConfig;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    const t5 = String(t4);
    let t6;
    if ($[11] !== t5) {
      t6 = translate("support.global.ai.subheading", {
        url: t5
      });
      $[11] = t5;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    subTitle = t6;
  }
  let t4;
  if ($[13] !== type) {
    t4 = type === "student" ? <ImageCdn src={fAQSrc} width={82} height={96} /> : <ImageCdn src={supportCompanionSrc} width={102} height={96} />;
    $[13] = type;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== subTitle || $[16] !== t4 || $[17] !== title) {
    t5 = <Header title={title} subTitle={subTitle} image={t4} />;
    $[15] = subTitle;
    $[16] = t4;
    $[17] = title;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== hasHelpSessionStarted || $[20] !== onSwitchHelpType || $[21] !== type) {
    t6 = !hasHelpSessionStarted && <Callout type="info"><LinkHandler onClickHandlers={{
        switch: onSwitchHelpType
      }}>{type === "employer" ? <Translate unsafe={true} content="support.business.candidate_help_switch.employer" /> : <Translate unsafe={true} content="support.business.candidate_help_switch.student" />}</LinkHandler></Callout>;
    $[19] = hasHelpSessionStarted;
    $[20] = onSwitchHelpType;
    $[21] = type;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t5 || $[24] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
}